export interface User {
    email: string;
    fullName: string;
    firstName: string;
    lastName: string;
    phoneNumber: string;
    nationalIdNumber: string;
    role?: string;
    gender?: string;
    permissions?: string[];
    organizationId?: string;
    organizationName?: string;
    profilePictureUrl?: string;
    occupation?: string;
    trackingLevel?: string;
    assignedLocations?: {
      id: string;
      name: string;
      type: string;
      code?: string;
      fullLocationNames?: {
        districtName?: string;
        sectorName?: string;
        cellName?: string;
        villageName?: string;
      };
    }[];
  }

  export interface AuthState {
    user: User | null;
    token: string | null;
    loading: boolean;
    error: string | null;
    isAuthenticated: boolean;
  }

  export const initialAuthState: AuthState = {
    user: null,
    token: null,
    loading: false,
    error: null,
    isAuthenticated: false
  };
